import { useAppSelector } from 'src/hooks';
import { Grid } from '@mui/material';
import TableSkeletonContainer from './table-skeleton';
import RetailPriceSimulationTable from '../retail-price-simulation-table/retail-price-simulation';
import OwnKpiSimulationTable from '../own-kpi-simulation-table/own-kpi-simulation-table';

interface ISimulationTableProps {
  kpiSelection: string;
  columns: any;
  retailerColumns: any;
  externalColumnData?: any;
  externalRetailerData?: any;
  visibleColumns?: any;
  activeHeader?: any;
}

export default function SimulationTableContainer({
  kpiSelection,
  columns,
  retailerColumns,
  externalColumnData,
  externalRetailerData,
  visibleColumns,
  activeHeader
}: ISimulationTableProps) {
  const { fetchingPricingSimulationData, toggle1, toggle2 } = useAppSelector(
    (state) => state.pricingSimulator
  );

  return (
    <Grid container>
      {fetchingPricingSimulationData && (
        <Grid item xs={12}>
          <TableSkeletonContainer rowLength={10} headerLength={6} />
        </Grid>
      )}
      {!fetchingPricingSimulationData && (
        <Grid item xs={12}>
          {kpiSelection === toggle1.name && <OwnKpiSimulationTable columns={columns} externalColumnData={externalColumnData} visibleColumns={visibleColumns} activeHeader={activeHeader}/>}
          {kpiSelection === toggle2.name && <RetailPriceSimulationTable columns={retailerColumns} externalRetailerData={externalRetailerData} visibleColumns={visibleColumns} activeHeader={activeHeader}/>}
        </Grid>
      )}
    </Grid>
  );
}
